import {
    AdministratorSearchDto, CreateAdministratorDto, ErrorResponseDto, FindAllByDto, FindAdminAutocompleteDto,
    SuccessResponseDto, UpdateAdministratorDto, HistoricResponseDto, SearchHistoricDto, HistoricDetailsResponseDto,
    UpdatePasswordDto, RefreshMenuDto, Menus, SearchAdministratorDto,
    FilterByIdsDto
} from '@/dtos';
import { Administrator } from '@/entities';
import { authHeader } from '@/helpers/utilities/auth-header';
import http from '@/helpers/apis/http-auth';
import { validateToken } from '@/helpers/utilities';

class AdministratorService {
    async create(createAdministratorDto: CreateAdministratorDto): Promise<SuccessResponseDto<Administrator> | ErrorResponseDto> {
        await validateToken();
        const result = await http.post('/admin/administrators/create', createAdministratorDto,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async search(searchDto: SearchAdministratorDto): Promise<SuccessResponseDto<AdministratorSearchDto>> {
        await validateToken();
        const result = await http.get('/admin/administrators/search', {
            params: searchDto,
            headers: authHeader(),
            withCredentials: true
        });
        return result.data;
    }

    async findByIds(params: FilterByIdsDto): Promise<SuccessResponseDto<Administrator[]>> {
        await validateToken();
        const result = await http.get('/admin/administrators/by-ids',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            });
        return result.data;
    }

    async findAllAutocomplete(params?: FindAdminAutocompleteDto): Promise<SuccessResponseDto<Administrator[]>> {
        await validateToken();
        const result = await http.get('/admin/administrators/all-autocomplete', {
            params: params,
            headers: authHeader(),
            withCredentials: true
        });
        return result.data;
    }

    async findAllExport(params: SearchAdministratorDto): Promise<SuccessResponseDto<Administrator[]>> {
        await validateToken();
        const result = await http.get('/admin/administrators/all-export', {
            params: params,
            headers: authHeader(),
            withCredentials: true
        });
        return result.data;
    }

    async findById(idAdministrator: number): Promise<SuccessResponseDto<Administrator>> {
        await validateToken();
        const result = await http.get(`/admin/administrators/${idAdministrator}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async update(idAdministrator: number, updateAdministratorDto: UpdateAdministratorDto): Promise<SuccessResponseDto<Administrator> | ErrorResponseDto> {
        await validateToken();
        const result = await http.patch(`/admin/administrators/update/${idAdministrator}`, updateAdministratorDto,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async updatePassword(idAdministrator: number, updateAdministratorDto: UpdatePasswordDto): Promise<SuccessResponseDto<Administrator>> {
        const result = await http.patch(`/admin/administrators/update-password/${idAdministrator}`,
            updateAdministratorDto, { withCredentials: true }
        );
        return result.data;
    }

    async uploadImage(file: File, admin_id: number) {
        await validateToken();

        const formData = new FormData();
        formData.append("image", file);

        const result = await http.post(`/admin/administrators/upload-image/${admin_id}`, formData, {
            headers: { ...authHeader(), "Content-Type": "multipart/form-data" }, withCredentials: true
        });
        return result.data;
    }

    async getHistoric(idAdministrator: number): Promise<SuccessResponseDto<HistoricResponseDto>> {
        await validateToken();
        const result = await http.get(`/admin/administrators/historic/${idAdministrator}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async getHistoricDetails(params: SearchHistoricDto): Promise<SuccessResponseDto<HistoricDetailsResponseDto[]>> {
        await validateToken();
        const result = await http.get(`/admin/administrators/historic-details`,
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async refreshMenu(params: RefreshMenuDto): Promise<SuccessResponseDto<Menus[]>> {
        await validateToken();
        const result = await http.get(`/admin/administrators/refresh-menu`,
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }


}

export default new AdministratorService;